import { useState } from "react";
import { useLocation } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { useLanguage } from "@/context/LanguageContext";
import { useRegisterModal } from "@/context/RegisterModalContext";

const WHATSAPP_NUMBER = "528714727508";
const DEFAULT_MESSAGE = {
  es: "Hola, quiero información sobre distribuir mi música con Doble R Records",
  en: "Hi, I'd like information about distributing my music with Doble R Records",
  pt: "Olá, gostaria de informações sobre distribuir minha música com a Doble R Records",
};

export const FloatingWhatsApp = () => {
  const location = useLocation();
  const { language, t } = useLanguage();
  const { isOpen } = useRegisterModal();
  const [hovered, setHovered] = useState(false);

  if (location.pathname.startsWith("/admin") || location.pathname.startsWith("/smartlink") || isOpen) return null;

  const message = DEFAULT_MESSAGE[language] || DEFAULT_MESSAGE.es;
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="WhatsApp"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setHovered(true)}
      onBlur={() => setHovered(false)}
      style={{ animation: "wa-pop-in 0.4s ease-out both" }}
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-[60] flex items-center justify-center transition-transform duration-200 hover:scale-110 active:scale-95"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
      <span className="relative w-[52px] h-[52px] sm:w-14 sm:h-14 flex items-center justify-center rounded-full bg-[#25D366] shadow-[0_8px_30px_-4px_rgba(37,211,102,0.6)] border border-white/10">
        <FaWhatsapp className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
      </span>
      <span
        data-testid="floating-whatsapp-tooltip"
        className={`hidden sm:block absolute right-[60px] whitespace-nowrap bg-[#0A0A0A] border border-white/10 text-white text-xs font-medium px-3 py-2 rounded-lg shadow-lg transition-all duration-150 ${
          hovered ? "opacity-100 translate-x-0" : "opacity-0 translate-x-2 pointer-events-none"
        }`}
      >
        {t.floatingWhatsapp.tooltip}
      </span>
    </a>
  );
};
